module.exports = __webpack_public_path__ + "media/photo/dev_girls-fb51fbcc.png";